import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';
var getMenuStyle = function getMenuStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary,
    fontColor = _getThemeData.fontColor;
  return css([".c7n-menu.c7n-menu,.c7n-menu-submenu-popup.c7n-menu-submenu-popup{.c7n-menu-item-selected,.c7n-menu-submenu-selected{color:", ";border-color:", ";}&.c7n-menu-dark{.c7n-menu-item-selected,.c7n-menu-item:hover{background-color:", ";color:", ";}}&.c7n-menu-light{.c7n-menu-item,.c7n-menu-item a{:hover{color:", ";border-color:", ";}}}&.c7n-menu-horizontal,&.c7n-menu-vertical{> .c7n-menu-submenu-open{color:", ";border-color:", ";}}&.c7n-steps-dropdown-menu .c7n-steps-item-icon > .icon{width:100%;height:100%;}}"], primary, primary, primary, fontColor, primary, primary, primary, primary);
};
var menuData = {
  name: 'menu',
  data: [{}],
  onlyTemplate: {
    // c7n-menu 颜色覆盖
    base: getMenuStyle
  }
};
export default menuData;